import React from 'react'

const AddIconV2 = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="10" transform="matrix(1 0 0 -1 0 20)" fill="#01B5DE"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3996 9.39998L5.59961 9.39998V10.6L14.3996 10.6V9.39998Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.39961 5.60002L9.39961 14.4L10.5996 14.4L10.5996 5.60002L9.39961 5.60002Z" fill="white"/>
      </svg>
    )
}

export default AddIconV2
